import axios from "axios";
import { refreshTokenRequest } from "./authRefresh";

// New API
export const axiosNewApiInstance = axios.create({
  baseURL: import.meta.env.VITE_NEW_API_URL,
});

export const setJWTAuthHeader = token => {
  axiosNewApiInstance.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;
  partsApiInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const clearJWTAuthHeader = () => {
  delete axiosNewApiInstance.defaults.headers.common["Authorization"];
  delete partsApiInstance.defaults.headers.common["Authorization"];
};

let isRefreshing = false;
let failedQueue = [];
let isLoggingOut = false;

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

axiosNewApiInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken || refreshToken === "undefined") {
      return Promise.reject(error);
    }

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/refresh") &&
      !originalRequest.url.includes("/auth/login")
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosNewApiInstance(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshTokenRequest();

        processQueue(null, newToken);

        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return axiosNewApiInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);

        if (!isLoggingOut) {
          isLoggingOut = true;

          clearJWTAuthHeader();
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");

          window.location.replace("/login");
        }

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// API for parts
export const partsApiInstance = axios.create({
  baseURL: import.meta.env.VITE_PARTS_API_URL,
});

// Old API
export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_OLD_API_URL,
});

export const dataBaseInstance = axios.create({
  baseURL: import.meta.env.VITE_DATABASE_API_URL,
});

export const setAuthHeader = api_key => {
  axiosInstance.defaults.headers.common["X-Api-Key"] = `${api_key}`;
};

export const clearAuthHeader = () => {
  axiosInstance.defaults.headers.common["X-Api-Key"] = "";
};
